import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { returnMiladiDateByStandardFormat } from '../../../../utils/utility/booking';
import { validateForm, validation } from '../../../../utils/validation';
import { returnAvatarList } from '../../../../utils/consts/avatar';
import {
  profileDepartmentApi,
  roleApi,
  usersApi,
} from '../../../../services/apis';
import {
  EmployeeContext,
  EmployeeDispatcherContext,
} from '../../../../contextProvider/employeeProvider';
import {
  MultiSelectDropDown,
  TelephoneInput,
  ValidationMessage,
  DatePicker,
  Confirmation,
  Button,
  Input,
  Modal,
  Dropdown,
  DepartmentManagement,
  Toast,
  RadioButton,
} from '../../../../component';
import './employeesForm.scss';

const INITIAL_DATA = {
  profileId: '',
  id: 0,
  userName: '',
  password: '',
  firstName: '',
  lastName: '',
  email: '',
  roles: [],
  roleName: [],
  departmentId: 0,
  basicInfo: {
    day: '',
    month: '',
    year: '',
    gender: '',
    birthDate: '',
    nationalCode: '',
    identityNo: '',
    passportNo: '',
    mobile: '',
    mobileWithoutCode: '',
    countryAbr: '',
    avatar: '1.png',
  },
};

class EmployeeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: Object.values(this.props.updateEmployeeData).length
        ? structuredClone(this.props.updateEmployeeData)
        : structuredClone(INITIAL_DATA),
      roleList: [],
      departmentList: [],
      errors: [],
      activicationStatus: 'active',
      alertType: '',
      alertBody: '',
      employeeAvatar: '1.png',
      alertMessage: 'user.employeeadd',
      toastState: 'success',
      showModal: false,
      disabledPassword: false,
      loading: false,
      toast: false,
      isShowAlert: false,
      isUpdate: false,
      changeLogoModal: false,
    };
  }

  validationCheck = () => {
    const { result, error } = this.validate();
    this.setState({ errors: error });
  };

  async componentDidMount() {
    const {
        data,
        data: {
          basicInfo: { day, month, year },
        },
      } = this.state,
      { profileId, updateEmployeeData } = this.props;
    try {
      await roleApi.getAll().then(({ payload: { data } }) => {
        this.setState({ roleList: data });
      });
      let departmentList = await profileDepartmentApi
        .getAllByProfileId({
          profileId: profileId,
          pageNumber: 1,
          itemPerPage: 20,
        })
        .then(({ payload: { data } }) => data.rows);
      if (Object.values(updateEmployeeData).length) {
        data.basicInfo.birthDate = `${year}-${month}-${day}`;
        this.setState(
          {
            data,
            employeeAvatar: data?.basicInfo?.avatar,
            disabledPassword: true,
            departmentList,
            activicationStatus: data.isActive ? 'active' : 'disActive',
          },
          () => this.validationCheck(),
        );
      } else {
        this.setState({
          disabledPassword: false,
          departmentList,
          data,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.updateEmployeeData !== this.props.updateEmployeeData) {
      this.setState({
        data: structuredClone(INITIAL_DATA),
        disabledPassword: false,
        errors: [],
      });
    }
  }

  addEmployee = async () => {
    try {
      const { data, employeeAvatar, activicationStatus } = this.state;
      data.profileId = data.id
        ? parseInt(data.profileId)
        : parseInt(localStorage.getItem('stakeholder') || 0);
      data.userName = data.email;
      data.isActive = activicationStatus === 'active';
      data.basicInfo.avatar = employeeAvatar;
      data.basicInfo.mobileWithoutCode = data.basicInfo.mobile;
      if (data.basicInfo.birthDate) {
        let standardDateFormat = data.basicInfo.birthDate.split('-') || '';
        data.basicInfo.year = standardDateFormat[0] || '';
        data.basicInfo.day = standardDateFormat[2] || '';
        data.basicInfo.month = standardDateFormat[1] || '';
      }
      this.setState({ loading: true });
      const { status } = await usersApi.addEmployee({ data });
      if (status === 200) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
          this.setState(
            {
              toast: true,
              alertMessage: 'user.employeeadd',
              toastState: 'success',
              data: structuredClone(INITIAL_DATA),
              activicationStatus: 'active',
              errors: [],
            },
            () =>
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              }),
          );
      }
    } catch (error) {
      if (error?.data?.errMessage === 'username is duplicated') {
        this.setState({
          toast: true,
          alertMessage: 'user.duplicatedusername',
          toastState: 'danger',
        });
      } else
        this.setState({
          toast: true,
          alertMessage: 'user.tryagain',
          toastState: 'danger',
        });
    } finally {
      this.setState({ loading: false, errors: [] }, () =>
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        }),
      );
    }
  };

  updateEmployee = async () => {
    try {
      const { data, employeeAvatar, activicationStatus } = this.state;
      data.profileId = data.id
        ? parseInt(data.profileId)
        : parseInt(localStorage.getItem('stakeholder') || 0);
      data.userName = data.email;
      data.isActive = activicationStatus === 'active';
      data.basicInfo.avatar = employeeAvatar;
      data.basicInfo.mobileWithoutCode = data.basicInfo.mobile;
      if (data.basicInfo.birthDate) {
        let standardDateFormat = data.basicInfo.birthDate.split('-') || '';
        data.basicInfo.year = standardDateFormat[0] || '';
        data.basicInfo.day = standardDateFormat[2] || '';
        data.basicInfo.month = standardDateFormat[1] || '';
      }
      this.setState({ loading: true });
      if (data.id) {
        const { status } = await usersApi.updateEmployee({ data });

        if (status === 200) {
          this.setState({
            toast: true,
            alertMessage: 'profile.editEmployeeSuccessfully',
            toastState: 'success',
            data: structuredClone(INITIAL_DATA),
            employeeAvatar: '1.png',
            activicationStatus: 'active',
            disabledPassword: false,
            errors: [],
          });
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    } catch (error) {
      if (error?.errMessage === 'username is duplicated') {
        this.setState({
          toast: true,
          alertMessage: 'user.duplicatedusername',
          toastState: 'danger',
        });
      } else
        this.setState({
          toast: true,
          alertMessage: 'user.tryagain',
          toastState: 'danger',
        });
    } finally {
      this.setState({ loading: false, errors: [] });
    }
  };

  updateDepartmentList = async () => {
    try {
      const { profileId } = this.props;
      const {
        payload: { data },
      } = await profileDepartmentApi.getAllByProfileId({
        profileId: profileId,
        itemPerPage: 20,
        pageNumber: 1,
      });
      this.setState({
        departmentList: data.rows,
        toast: true,
        alertMessage: 'department.departmentadd',
        toastState: 'success',
      });
    } catch (error) {
      this.setState({
        toast: true,
        toastState: 'danger',
        alertMessage: 'error.receiveerror',
      });
    }
  };

  validate = () => {
    const {
      disabledPassword,
      data: {
        firstName,
        lastName,
        departmentId,
        roles,
        email,
        basicInfo,
        password,
      },
    } = this.state;
    const { error, result } = validateForm({
      lastName: validation.string(lastName).required().errors,
      firstName: validation.string(firstName).required().errors,
      departmentId: validation.required(departmentId).errors,
      gender: validation.required(basicInfo.gender).errors,
      passportNo: validation.text(basicInfo.passportNo).required().errors,
      identityNo: validation.number(basicInfo.identityNo).required().errors,
      roles: validation.array(roles).required().errors,
      email: validation.email(email).required().errors,
      birthDate: validation.any(basicInfo.birthDate).required().errors,
      password: disabledPassword
        ? validation.any(password).required().errors
        : validation.password(password).required().errors,
      nationalCode: validation
        .iranianNationalCode(basicInfo.nationalCode)
        .required().errors,
    });
    return { result, error };
  };

  handleChange = (event, isMain = false) => {
    const { name, value } = event.target || event.currentTarget;
    const {
      data,
      errors,
      data: { basicInfo },
    } = this.state;
    isMain ? (basicInfo[name] = value) : (data[name] = value);
    const { error } = this.validate();
    this.setState({
      errors: {
        ...errors,
        [name]: error[name],
      },
      data,
    });
  };

  handleTelephoneInput = (value) => {
    let { data } = this.state;
    data.basicInfo = {
      ...data.basicInfo,
      mobile: value.fullNumber,
      countryAbr: value.country,
    };
    this.setState({ data });
  };

  handleMultiSelectChange = ({ stateName, value }) => {
    let { data } = this.state;
    const valueArray = value?.map(({ id }) => id);
    data[stateName] = valueArray;
    this.setState({ data });
  };

  RenderComfirmation = () => {
    const { isShowAlert, alertType, alertBody } = this.state;
    const { intl } = this.props;
    return (
      <Confirmation
        isConfirmation={false}
        onReject={() => this.setState({ isShowAlert: false })}
        show={isShowAlert}
        type={alertType}
        closeTime={2000}
        body={intl.formatMessage({ id: alertBody })}
        defaultDescription={intl.formatMessage({ id: alertBody })}
        title={intl.formatMessage({ id: alertBody })}
      />
    );
  };

  AddEmployeeForm = ({ userInfo }) => {
    const {
      roleList,
      departmentList,
      data,
      errors,
      disabledPassword,
      activicationStatus,
    } = this.state;
    const { language, intl } = this.props;
    return (
      <div className=" add-emploee-form-container d-flex align-items-center justify-content-center">
        <div className="d-flex flex-column flex-wrap row w-100">
          <div className="d-flex flex-sm-row flex-column pb-4 m-0 col-sm-6 col-12 px-3 pt-sm-0 pt-3">
            <label className="px-2 text-start">
              <FormattedMessage id="profile.status" />
              <span className="px-2">:</span>
            </label>
            <div className="d-flex justify-content-start flex-fill px-sm-0 px-3 pb-sm-0 pb-2 text-nowrap">
              <RadioButton
                name="activicationStatus"
                label="profile.active"
                inputClassName="font-weight-bold m-0 font-msmall"
                checked={activicationStatus === 'active'}
                onChange={(event) =>
                  this.setState({
                    activicationStatus: event.target.value,
                  })
                }
                value={'active'}
              />
              <RadioButton
                name="activicationStatus"
                label="profile.disactive"
                inputClassName="font-weight-bold m-0 px-2 font-msmall"
                checked={activicationStatus === 'disActive'}
                onChange={(event) =>
                  this.setState({
                    activicationStatus: event.target.value,
                  })
                }
                value={'disActive'}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap w-100">
            <div className="col-sm-6 col-12 pb-sm-4 pb-3">
              <Input
                name="firstName"
                type="text"
                label={intl.formatMessage({
                  id: `profile.firstname`,
                })}
                value={data?.firstName}
                onChange={(e) => this.handleChange(e, false)}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                language={language}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
                tabIndex="1"
              />
              <ValidationMessage errors={errors?.firstName} />
            </div>
            <div className="col-sm-6 col-12 pb-sm-4 pb-3">
              <Input
                name="lastName"
                type="text"
                label={intl.formatMessage({
                  id: `profile.lastname`,
                })}
                value={data?.lastName}
                onChange={(e) => this.handleChange(e, false)}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                language={language}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
                tabIndex="2"
              />
              <ValidationMessage errors={errors?.lastName} />
            </div>
            <div className="col-sm-6 col-12 pb-sm-4 pb-3">
              <Input
                name="email"
                type="text"
                label={intl.formatMessage({
                  id: `profile.email`,
                })}
                value={data?.email}
                onChange={(e) => this.handleChange(e, false)}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                language={language}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
                tabIndex="3"
              />
              <ValidationMessage errors={errors?.email} />
            </div>
            <div className="col-sm-6 col-12 pb-sm-4 pb-3">
              <Input
                name="password"
                type="text"
                label={intl.formatMessage({
                  id: `profile.password`,
                })}
                value={disabledPassword ? '***********' : data?.password}
                onChange={(e) => this.handleChange(e, false)}
                className={''}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                language={language}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
                disabled={disabledPassword}
                tabIndex="4"
              />
              <ValidationMessage errors={errors?.password} />
            </div>
            <div className="col-sm-6 col-12 pb-sm-4 pb-3">
              <Input
                name="nationalCode"
                type="text"
                label={intl.formatMessage({
                  id: `profile.nationalcode`,
                })}
                value={data?.basicInfo?.nationalCode}
                onChange={(e) => this.handleChange(e, true)}
                themeMode="light"
                outSideLabelClass="text-start"
                outSideLabelPosition="top"
                outSideLabel={true}
                language={language}
                inputClassName={'font-normal height-input-profile px-sm-3 px-3'}
                tabIndex="5"
              />
              <ValidationMessage errors={errors?.nationalCode} />
            </div>
            <div className="col-sm-6 col-12 pb-sm-0 pb-4 mb-sm-0 mb-4">
              <div className="px-3 pb-2 text-star align-self-start text-start dark-text-color">
                <FormattedMessage id="profile.mobile" />
              </div>
              <TelephoneInput
                telephoneNumber={data?.basicInfo?.mobile}
                countryAbr={data?.basicInfo.countryAbr.toLowerCase()}
                onChange={(e) => {
                  this.handleTelephoneInput(e);
                }}
                containerClass={'height-55px bg-third-light'}
                tabIndex="6"
              />
            </div>
            <div className="col-sm-6 col-12">
              <Dropdown
                classNames="bg-third-light height-55px"
                outSideLabelClass={'dropDown-fontSize'}
                name="departmentId"
                id="departmentId"
                label="profile.department"
                value={data['departmentId']}
                options={{
                  data: departmentList,
                  label: 'name',
                  value: 'id',
                  isMultiLanguage: true,
                }}
                onChange={this.handleChange}
                theme="light"
                iconNameDrp={null}
                outSideLabel={true}
                withoutShadow={true}
                labelPosition="top"
                maxHeight="55px"
                tabIndex="7"
              />
              <div className="w-100 d-flex flex-row justify-content-between align-items-center pb-3">
                <ValidationMessage errors={errors?.departmentId} />
                <div className=" pt-1 font-small department-link text-end">
                  <a
                    className="cursor-pointer px-2 font-sm-msmall font-smaller text-decoration-underline text-nowrap"
                    onClick={() => this.setState({ showModal: true })}
                  >
                    <FormattedMessage id="profile.addDepartment" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-12 pb-sm-0 pb-3 mb-sm-0 mb-2">
              <Dropdown
                classNames="bg-third-light height-55px"
                outSideLabelClass={'dropDown-fontSize'}
                name="gender"
                id="gender"
                label="profile.gender"
                value={data.basicInfo['gender']}
                options={{
                  data: [
                    { value: 1, name: { en: 'Male', fa: 'آقا' } },
                    { value: 2, name: { en: 'Female', fa: 'خانم' } },
                  ],
                  label: 'name',
                  value: 'value',
                  isMultiLanguage: true,
                }}
                onChange={({ currentTarget }) =>
                  this.handleChange(
                    {
                      target: {
                        value: currentTarget.value,
                        name: 'gender',
                      },
                    },
                    true,
                  )
                }
                theme="light"
                outSideLabel={true}
                iconNameDrp={null}
                withoutShadow={true}
                maxHeight="55px"
                tabIndex="8"
              />
              <ValidationMessage errors={errors?.gender} />
            </div>

            <div
              className="collapse more-detail-collapse d-flex flex-wrap w-100"
              id="showMoreDetail"
            >
              <div className="col-sm-6 col-12  pb-sm-2 pb-1 mb-sm-0 mb-2">
                <Input
                  name={'passportNo'}
                  label={intl.formatMessage({
                    id: 'profile.passportNumber',
                  })}
                  value={data.basicInfo['passportNo']}
                  onChange={(e) => this.handleChange(e, true)}
                  className={''}
                  themeMode="light"
                  outSideLabelClass="text-start"
                  outSideLabelPosition="top"
                  iconUrl={null}
                  outSideLabel={true}
                  inputClassName={
                    'font-normal height-input-profile px-sm-3 px-3'
                  }
                  tabIndex="9"
                />
                <ValidationMessage errors={errors?.passportNo} />
              </div>
              <div className="col-sm-6 col-12 pb-2">
                <Input
                  name={'identityNo'}
                  label={intl.formatMessage({
                    id: 'profile.identityno',
                  })}
                  value={data.basicInfo['identityNo']}
                  onChange={(e) => this.handleChange(e, true)}
                  className={''}
                  themeMode="light"
                  outSideLabelClass="text-start"
                  outSideLabelPosition="top"
                  iconUrl={null}
                  outSideLabel={true}
                  inputClassName={
                    'font-normal height-input-profile px-sm-3 px-3'
                  }
                  tabIndex="10"
                />
                <ValidationMessage errors={errors?.identityNo} />
              </div>
              <div className="col-sm-6 col-12 pt-3 ">
                <label className="px-3 pb-2 text-start w-100 m-0">
                  <FormattedMessage
                    id="profile.employeeRole"
                    children={(msg) => <>{msg}</>}
                  />
                </label>
                <MultiSelectDropDown
                  name="roles"
                  label={''}
                  id="roles"
                  data={roleList}
                  value={data?.roleName}
                  show="name"
                  send="id"
                  onClick={this.handleMultiSelectChange}
                  theme="light"
                  tabIndex="11"
                />
                <ValidationMessage errors={errors?.roles?.[0]} />
              </div>
              <div className="col-sm-6 col-12 pt-sm-3 pt-4">
                <DatePicker
                  name={'birthDate'}
                  value={data.basicInfo['birthDate']}
                  placeholder={intl.formatMessage({
                    id: 'profile.birthdate',
                  })}
                  className="pt-4"
                  themeMode="light"
                  onChange={(date) => {
                    this.handleChange(
                      {
                        target: {
                          value: date
                            ? returnMiladiDateByStandardFormat(date)
                            : '',
                          name: 'birthDate',
                        },
                      },
                      true,
                    );
                  }}
                  tabIndex={'12'}
                />
                <ValidationMessage errors={errors?.birthDate} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { AddEmployeeForm } = this;
    const {
      showModal,
      toast,
      alertMessage,
      toastState,
      loading,
      isShowAlert,
      employeeAvatar,
      changeLogoModal,
      data,
    } = this.state;
    const {
      intl,
      language: { direction },
      updateEmployeeData: { id },
      changeSelectedTab,
      profileId,
    } = this.props;
    const { RenderComfirmation } = this;
    return (
      <EmployeeContext.Consumer>
        {(userInfo) => (
          <EmployeeDispatcherContext.Consumer>
            {(updateUserInfo) => (
              <>
                <Toast
                  isOpen={toast}
                  onClose={() => this.setState({ toast: false })}
                  state={toastState}
                  position="bottom"
                  message={intl.formatMessage({
                    id: alertMessage,
                  })}
                  direction={direction}
                />
                <Modal
                  isOpen={showModal}
                  onClose={() => this.setState({ showModal: false })}
                  id="departmentManagement"
                >
                  <DepartmentManagement
                    profileId={profileId}
                    updateDepartmentList={(isDepartmentUpdate) =>
                      isDepartmentUpdate ? this.updateDepartmentList() : null
                    }
                  />
                </Modal>
                <Modal
                  isOpen={changeLogoModal}
                  onClose={() => this.setState({ changeLogoModal: false })}
                  modalName="changeLogoModal"
                  title={intl.formatMessage({
                    id: 'profile.selectavatar',
                  })}
                >
                  <div className="modal-body d-flex flex-row justify-content-between flex-wrap">
                    {returnAvatarList().map((item, index) => {
                      return (
                        <div key={index} className="px-sm-2 px-1">
                          <div
                            data-dismiss="modal"
                            className={'d-flex py-2'}
                            onClick={() =>
                              this.setState({
                                employeeAvatar: item,
                                changeLogoModal: false,
                              })
                            }
                          >
                            <img
                              src={require(`../../../../content/images/avatars/${item}`)}
                              className="cursor-pointer logo-size"
                              alt="avatar"
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Modal>
                <section className="col-12 px-responsive">
                  <div className="px-0">
                    <div className="bg-white border p-4 default-border-radius-small">
                      {isShowAlert && <RenderComfirmation />}
                      <div className="col-12 px-0 d-flex flex-xs-row flex-column mb-xs-4 mb-2 pb-1">
                        <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 col-12 px-md-3 px-0 ">
                          <div className="w-100 h-100 d-flex flex-row justify-content-start">
                            <img
                              className="img-fluid default-border-radius-small img-setup"
                              alt="add-personal"
                              src={require('../../../../content/images/elements/cv-online.png')}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-0 px-3 pt-xs-0 pt-3 d-flex flex-column justify-content-start align-items-start">
                          <span className="text-primary pt-md-5 pt-sm-4 pt-2 font-sm-xxlarge font-normal text-nowrap">
                            <FormattedMessage
                              id={`profile.${
                                data?.id ? 'editingInformation' : 'addEmployee'
                              }`}
                            />
                          </span>
                          <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
                            <p className="font-xl-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                              <FormattedMessage id="profile.textAddemplo" />
                            </p>
                            <div
                              style={{ zIndex: 1 }}
                              className="w-100 m-0 py-0 pt-1"
                            >
                              <div
                                className="d-flex w-100 cursor-pointer justify-content-start align-items-center"
                                onClick={() => {
                                  this.setState({ changeLogoModal: true });
                                }}
                              >
                                <img
                                  src={require(`../../../../content/images/avatars/${employeeAvatar}`)}
                                  className="add-avatar-size"
                                  alt="logo"
                                />
                                <span className="d-flex font-weight-bold px-2 font-smaller text-nowrap text-start">
                                  <FormattedMessage id="profile.selectavatar" />
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 pb-4 mb-2 text-dark px-0">
                        <AddEmployeeForm userInfo={userInfo} />
                      </div>
                      <div className="d-flex align-items-center justify-content-center mx-3 mx-sm-0 pb-sm-2 pb-0 mb-md-3 mb-sm-1 mb-0 mt-md-0 mt-3">
                        <div className="w-100 d-flex flex-sm-row flex-column-reverse mt-sm-0 mt-2">
                          <Button
                            name={`cancel-reload-employeeFrom`}
                            id={`cancel-reload-employeeFrom`}
                            label={intl.formatMessage({
                              id: data?.id
                                ? 'profile.cancel'
                                : 'profile.reload',
                            })}
                            className="btn-third mx-0 mx-sm-3 mb-2 mb-sm-0 mt-sm-0 mt-2"
                            onClick={() => {
                              data?.id
                                ? (window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth',
                                  }),
                                  changeSelectedTab('employeeList'))
                                : this.setState({
                                    data: structuredClone(INITIAL_DATA),
                                    errors: [],
                                  });
                            }}
                          />
                          <Button
                            name={`insert-data-employeeFrom`}
                            id={`insert-data-employeeFrom`}
                            label={intl.formatMessage({
                              id: data?.id
                                ? 'profile.editEmployeeInformation'
                                : 'profile.addEmployee',
                            })}
                            className=" btn-secondary  mx-0  mx-sm-3 mb-5 mb-sm-0"
                            disabled={!this.validate().result || loading}
                            loading={loading}
                            onClick={() =>
                              data?.id
                                ? this.updateEmployee()
                                : this.addEmployee()
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </>
            )}
          </EmployeeDispatcherContext.Consumer>
        )}
      </EmployeeContext.Consumer>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default connect(mapStateToProps)(withRouter(injectIntl(EmployeeForm)));
